import React from 'react';
import { Grid, Typography, Box, Breadcrumbs, Link } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { IconMathGreater } from '@tabler/icons';

const Breadcrumb = ({ items, title, action, sx }) => (
  <Box sx={{ mb: 3, mt: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', ...sx }}>
    <Box>
      <Typography sx={{ mb: 0.5, textTransform: 'uppercase', fontWeight: 900, fontSize: 20 }}>{title}</Typography>
      <Breadcrumbs 
        separator={<IconMathGreater size={12} />} 
        aria-label="breadcrumb"
      >
        {items?.map((item) => (
           <Link key={item.title} underline="hover" color="inherit" component={NavLink} to={item.to || '#'}>
             {item.title}
           </Link>
        ))}
      </Breadcrumbs>
    </Box>
    {action && <Box>{action}</Box>}
  </Box>
);

export default Breadcrumb;
